export const shouldReportApolloErrorToSentry = errorLike => {
  if (
    errorLike?.extensions ||
    errorLike?.path ||
    errorLike?.locations
  ) {
    return false;
  }

  const graphQLErrorMessage = String(errorLike?.message || errorLike || "")
    .toLowerCase()
    .replace(/\s+/g, " ")
    .trim();
  if (graphQLErrorMessage === "authentication_required") {
    return false;
  }

  const statusCode =
    errorLike?.statusCode || errorLike?.status || errorLike?.response?.status;
  if (typeof statusCode === "number" && statusCode >= 400) {
    return false;
  }

  const errorName = errorLike?.name || "";
  if (errorName === "ServerError" || errorName === "ApolloError") {
    return false;
  }

  return true;
};
